/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
const state = {
    gameVersion: [],
    sdkVersion: [],
    packageList: [],
    androidPackageList: [],
    packageStoreList: [],
    androidPackageStoreList: [],
    releasePlan: [],
    termsList: [],
    data: {}
};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
const actions = {
    GET_SDK_VERSION ({state, commit, dispatch, rootState}, args) {
        let data = [];
        rootState.$helper.request.get('/sdk/' + args.platform + '/versions', {}).then(
            function (res) {
                data = res.data.sdk_versions;
                commit('_sdkVersion', data);
            }
        ).catch(function (res) {
            dispatch('ERROR_HANDLE', res, {root: true});
        });
    },

    GET_GAME_VERSION ({state, commit, dispatch, rootState}, args) {
        let data = [];
        let gameCode = rootState.$helper.helper.getGameCode().game_code;
        rootState.$helper.request.get('/games/' + gameCode + '/versions', {game_code: gameCode}).then(
            function (res) {
                data = res.data.versions;
                commit('_gameVersion', data);
            }
        ).catch(function (res) {
            dispatch('ERROR_HANDLE', res, {root: true});
        });
    },

    NEW_GAME_VERSION ({state, commit, dispatch, rootState}, args) {
        let data = [];
        let gameCode = rootState.$helper.helper.getGameCode().game_code;
        rootState.$helper.request.put('/games/' + gameCode + '/versions/new', {version: args.version}).then(
            function (res) {
                data = res.data.created;
                commit('_newGameVersion', data);
            }
        ).catch(function (res) {
            dispatch('ERROR_HANDLE', res, {root: true});
        });
    },

    GET_PACKAGE_LIST ({state, commit, dispatch, rootState}, args) {
        let data = [];
        let gameCode = rootState.$helper.helper.getGameCode().game_code;
        rootState.$helper.request.get('/ajaxrela/getpackagenamelist', {
            game_code: gameCode,
            platform: args.platform
        }).then(
            function (res) {
                data = res.data.result;
                commit('_packageList', data);
            }
        ).catch(function (res) {
            dispatch('ERROR_HANDLE', res, {root: true});
        });
    },
    GET_PACKAGE_STORE ({state, commit, dispatch, rootState}, args) {
        let data = [];
        return rootState.$helper.request.get('/ajaxrela/getpackagenamestorelist', {package_id: args.package_id}).then(
            function (res) {
                data = res.data.result;
                commit('_packageStoreList', data);
                return res;
            }
        ).catch(function (res) {
            dispatch('ERROR_HANDLE', res, {root: true});
        });
    },
    PUT_RELEASE_SUBMIT ({state, commit, dispatch, rootState}, args) {
        let data = [];
        let gameCode = rootState.$helper.helper.getGameCode().game_code;
        return rootState.$helper.request.put('/games/' + gameCode + '/releases/new', args).then(
            (res) => {
                data = res.data.created;
                commit('_setData', data);
                return true;
            }
        );
    },
    GET_RELEASE_PLAN ({state, commit, dispatch, rootState}, args) {
        let gameCode = rootState.$helper.helper.getGameCode().game_code;
        let data = [];
        if (args.plan_id) {
            return rootState.$helper.request.get('/games/' + gameCode + '/plans/' + args.plan_id).then(
                function (res) {
                    data[0] = res.data.plan;
                    commit('_releasePlan', data);
                    return data;
                }
            ).catch(function (res) {
                dispatch('ERROR_HANDLE', res, {root: true});
            });
        }
        else {
            return rootState.$helper.request.get('/games/' + gameCode + '/plans',
                {
                    platform: args.platform,
                    sdk_version_id: args.sdk_version_id,
                    store_id: args.store_id,
                    package_id: args.package_id,
                }).then(
                function (res) {
                    data = res.data.plans;
                    commit('_releasePlan', data);
                    return data;
                }
            ).catch(function (res) {
                dispatch('ERROR_HANDLE', res, {root: true});
            });
        }
    },
    GET_EDIT_RELEASE ({state, commit, dispatch, rootState}, args) {
        let gameCode = rootState.$helper.helper.getGameCode().game_code;
        let data = [];
        commit("PRIVATE_LOADING", true, { root: true });
        return rootState.$helper.request.get('/games/' + gameCode + '/releases/' + args.release_id,
            {
                platform: args.platform,
            }).then(
            function (res) {
                data = res.data.release;
                commit('_setData', data);
                commit("PRIVATE_LOADING", false, { root: true });
                return data;
            }
        ).catch(function (res) {
            commit("PRIVATE_LOADING", false, { root: true });
            dispatch('ERROR_HANDLE', res, {root: true});
        });
    },
    PUT_RELEASE_EDIT_SUBMIT ({state, commit, dispatch, rootState}, args) {
        let data = [];
        let gameCode = rootState.$helper.helper.getGameCode().game_code;
        return rootState.$helper.request.put('/games/' + gameCode + '/releases/' + args.release_id, args).then(
            function (res) {
                data = res.data.edited;
                commit('_setData', data);
                return data;
            }
        ).catch(function (res) {
            dispatch('ERROR_HANDLE', res, {root: true});
        });
    },
    PUT_RELEASE_COPY_SUBMIT ({state, commit, dispatch, rootState}, args) {
        let data = [];
        let gameCode = rootState.$helper.helper.getGameCode().game_code;
        rootState.$helper.request.put('/games/' + gameCode + '/releases/new', args).then(
            function (res) {
                data = res.data.created;
                if (data) {
                    dispatch('ALERT_HANDLE', {
                        message: '复制成功!',
                        callback () {
                            rootState.$helper.helper.route('sdk/releaseslist', {platform: args.platform});
                        }
                    }, {root: true});
                }
                else {
                    dispatch('ALERT_HANDLE', {
                        message: '复制失败!',
                        callback () {
                            rootState.$helper.helper.route('sdk/releaseslist');
                        }
                    }, {root: true});
                }
            }
        ).catch(function (res) {
            dispatch('ERROR_HANDLE', res, {root: true});
        });
    },
    GET_TERMS_LIST ({state, commit, dispatch, rootState}, args) {
        let gameCode = rootState.$helper.helper.getGameCode().game_code;
        let data = [];
        rootState.$helper.request.get('/games/' + gameCode + '/termslist', args).then(
            function (res) {
                data = res.data.terms;
                commit('_termsList', data);
            }
        ).catch(function (res) {
            dispatch('ERROR_HANDLE', res, {root: true});
        });
    }
};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
const getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
const mutations = {
    _setData(state, args) {
        state.data = args;
    },
    _sdkVersion (state, args) {
        state.sdkVersion = args;
    },
    _gameVersion (state, args) {
        state.gameVersion = args;
    },
    _packageList (state, args) {
        state.packageList = args;
    },
    _packageStoreList (state, args) {
        state.packageStoreList = args;
    },
    _newGameVersion (state, args) {
        let newVersionData = [].concat(args, state.gameVersion);
        state.gameVersion = newVersionData;
    },
    _releasePlan(state, args) {
        state.releasePlan = args;
    },
    _termsList (state, args) {
        state.termsList = args;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./website/store/modules/sdk/releasesEdit.js